import { StoreDevtoolsModule } from '@ngrx/store-devtools';

export const storeDevtoolsImports = [
  StoreDevtoolsModule.instrument({
    maxAge: 25,
    logOnly: false,
    autoPause: true,
    trace: false,
    traceLimit: 75,
    connectInZone: false,
  }),
];
